// extracted by mini-css-extract-plugin
export default {"cartBck":"Privacy_cartBck__rdtMB","changeBck":"Privacy_changeBck__sJgIo","greenBck":"Privacy_greenBck__ClnCN"};